import http from "V2.0/services/httpService";

function getWidget({ workspaceId, assistantId }) {
  return http.get(`/widget/whitelabelGetWidget/${workspaceId}/${assistantId}`);
}

function createWidget({ workspaceId, assistantId }) {
  return http.post(
    `/widget/whitelabelCreateWidget/${workspaceId}/${assistantId}`
  );
}

function updateWidget({ workspaceId, assistantId, payload }) {
  return http.put(
    `/widget/whitelabelUpdateWidget/${workspaceId}/${assistantId}`,
    payload
  );
}

export { createWidget, getWidget, updateWidget };
